/* eslint-disable no-use-before-define */
import React from 'react';
import FieldTypesEnum from '../../../Enums/FieldTypesEnum';
import DataTableActionMenu from '../../../Elements/DataTable/DataTableActionMenu';
import LongText from '../../../Elements/LongText';
import ErrorMessage from '../../../Elements/ErrorMessage';
import JsxHelper from '../../../Helpers/JsxHelper';

export default class ProjectAssociableTpSurveyItem
{
  constructor (item)
  {
    if (item === undefined)
    {
      this.Selected = false;
      this.TpSurveyId = '';
      this.ThirdPartySurveyName = '';
      this.ThirdPartySurveyId = '';
      this.IsUninvoiceable = '';
      this.TpClientLinkId = '';
      this.SurveyType = '';
      this.ThirdPartySource = '';
      this.IsActivated = '';
      this.CreatedBy = '';
      this.CreatedOnUtc = '';
      this.ModifiedBy = '';
      this.ModifiedOnUtc = '';
      return;
    }
    this.Selected = item.selected;
    this.TpSurveyId = item.tpSurveyId;
    this.ThirdPartySurveyName = item.thirdPartySurveyName;
    this.ThirdPartySurveyId = item.thirdPartySurveyId;
    this.IsUninvoiceable = item.isUninvoiceable;
    this.TpClientLinkId = item.tpClientLinkId;
    this.SurveyType = item.surveyType;
    this.ThirdPartySource = item.thirdPartySource;
    this.IsActivated = item.isActivated;
    this.CreatedBy = item.createdBy;
    this.CreatedOnUtc = item.createdOnUtc;
    this.ModifiedBy = item.modifiedBy;
    this.ModifiedByUserName = item.modifiedByUserName;
    this.CreatedByUserName = item.createdByUserName;
    this.ModifiedOnUtc = item.modifiedOnUtc;
  }

  static NameOfTheIdField ()
  {
    return 'TpSurveyId';
  }

  static MoneyFields = [];

  static Currency ()
  {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary ()
  {
    return '';
  }

  static DateFields = [ 'CreatedOnUtc', 'ModifiedOnUtc' ];
  static BoolFields = [];

  static nameOfTheItemDetailList (item)
  {
    return item.ThirdPartyClientName;
  }

  static FieldsToShowInDataTable ()
  {
    // prettier-ignore
    return [
      { label: ProjectAssociableTpSurveyItem.getSelectedCellHeader, orderById: '', data: ProjectAssociableTpSurveyItem.getSelectedCellContent, minWidth: 20 },
      {
        label: 'Id',
        orderById: 'TpSurveyId',
        data: 'TpSurveyId',
        type: FieldTypesEnum.DataFieldWithDetails,
        minWidth: 70,
      },
      {
        label: 'Name',
        orderById: 'ThirdPartySurveyName',
        data: (item) => (
          <LongText
            text={item.ThirdPartySurveyName}
            maxLength={50}
          />
        ),
        type: FieldTypesEnum.PureDataField,
      },
      // { label: "Bravo Client Id", orderById: "BravoClientId", data: "BravoClientId", type: FieldTypesEnum.PureDataField, minWidth: "110px", },
      { label: 'Source', orderById: 'ThirdPartySource', data: 'ThirdPartySource', type: FieldTypesEnum.PureDataField },
      {
        label: 'Third-Party Survey Id',
        orderById: 'ThirdPartySurveyId',
        data: 'ThirdPartySurveyId',
        type: FieldTypesEnum.PureDataField,
      },
      { label: 'Is Activated', orderById: 'IsActivated', data: (item) => JsxHelper.YesNo(item.IsActivated) },
      { label: 'Modified On', orderById: 'ModifiedOnUtc', data: 'ModifiedOnUtc', type: FieldTypesEnum.PureDataField },
      //   { label: 'Modified By', orderById: 'ModifiedBy', data: 'ModifiedByUserName', type: FieldTypesEnum.PureDataField },
      {
        label: 'Actions',
        orderById: '',
        data: ProjectAssociableTpSurveyItem.getActionsCellContent,
        type: FieldTypesEnum.ActionButton,
      },
    ];
  }

  static clickOnSelect (item)
  {
    alert('Click');
  }

  static selectedStatus ()
  {
    return false;
  }

  static clickOnGlobalSelect (item, selected) { }

  static getSelectedCellHeader ()
  {
    return (
      <input
        type='checkbox'
        checked={ProjectAssociableTpSurveyItem.selectedStatus()}
        onChange={(e) =>
        {
          ProjectAssociableTpSurveyItem.clickOnGlobalSelect(e.target.checked);
        }}
      />
    );
  }

  static getSelectedCellContent (item)
  {
    if (item.Selected === undefined) item.Selected = false;
    return (
      <div className='text-center'>
        <input
          type='checkbox'
          checked={item.Selected}
          onClick={(e) =>
          {
            ProjectAssociableTpSurveyItem.clickOnSelect(item);
          }}
          onChange={(e) => { }} //Don't remove. This is necessary to eliminate the React warning!
        />
      </div>
    );
  }

  // prettier-ignore
  static FieldsToShowInListTable = [
    {
      tabName: "General", tabLabel: "General", icon: "fa-solid fa-users",
      data: [
        { name: "TpClientLinkId", label: "TpClientLink Id", className: "text-left" },
        { name: "ThirdPartyClientName", label: "Name", className: "text-left" },
        { name: "BravoClientId", label: "Bravo Client Id", className: "text-left" },
        { name: "ThirdPartyClientId", label: "Third-Party Client Id", className: "text-left" },
        { name: "ThirdPartySource", label: "Source", className: "text-left" },
        { name: "ModifiedOn", label: "ModifiedOn", className: "text-left" },
        { name: "ModifiedByUserName", label: "Modified By", className: "text-left", },
        { name: "CreatedOn", label: "Created On", className: "text-left" },
        { name: "CreatedByUserName", label: "Created By", className: "text-left", },
      ],
    },
  ];

  static getActionsCellContent (item)
  {
    return (
      <DataTableActionMenu
        options={[
          {
            text: item.IsActivated == true ? 'Deactivate Survey' : 'Activate Survey',
            onClick: () => ProjectAssociableTpSurveyItem.activateDeactivateFunction(item),
            iconName: 'fa-solid fa-xmark',
            roleKey: 'project_edit',
          },
        ]}
      />
    );
  }

  static activateDeactivateFunction (item)
  {
    if (item.IsActivated == true)
    {
      ProjectAssociableTpSurveyItem.deactivateSurveyFunction(item);
      return;
    }
    ProjectAssociableTpSurveyItem.activateSurveyFunction(item);
  }

  static activateSurveyFunction (item)
  {
    // ErrorMessage.SetApprove(
    //   <span>
    //     You will activate this third-party survey: {item.ThirdPartySurveyName} <br />
    //     Are you sure?
    //   </span>,
    //   () => this.clickOnActivateSurvey(item.TpClientLinkId)
    // );
    this.clickOnActivateSurvey(item);
  }

  static clickOnActivateSurvey = (item) =>
  {
    alert(`It is just a placeholder. Actual implementation will be done in the TpSurveyAdmin.js file.`);
  };

  static deactivateSurveyFunction = (item) =>
  {
    ErrorMessage.SetApprove(
      `<span>
        You will deactivate this third-party survey: ${item.ThirdPartySurveyName} <br />
        Are you sure?
      </span>`,
      () => this.clickOnDeactivateSurvey(item)
    );
  };

  static clickOnDeactivateSurvey = (item) =>
  {
    alert(`It is just a placeholder. Actual implementation will be done in the TpSurveyAdmin.js file.`);
  };
}
